import axios from 'axios';
import get from 'lodash.get';
import { from } from 'rxjs';

import { emptyArray } from 'ui-components/default-props/empty';

const CONFIG_TYPE_ORDERS = 'order';
const CONFIG_TYPE_SHIPMENTS = 'shipping';
const CONFIG_TYPE_CUSTOMERS = 'customer';
const CONFIG_TYPE_FULFILLMENTS = 'fulfillment';

const makeConfig = (filterView, configType) => {
  const { appliedFilters, gridViewId } = filterView;
  const configData = {
    appliedFilters,
    gridViewId,
  };
  return {
    gridConfigId: filterView.filterViewId,
    gridConfigTypeId: configType,
    gridConfigName: filterView.displayName,
    configData: JSON.stringify(configData),
  };
};

const doubleParseIfNecessary = (configData) => {
  const firstParse = JSON.parse(configData);
  if (typeof firstParse === 'string' && firstParse.length) {
    return JSON.parse(firstParse);
  }
  return firstParse;
};

const parseConfig = (gridConfig) => {
  // TODO - further backend investigation needed as to why the response is sending string escapes for quotes
  // 7.16 - POST response for saving existing views does not have this issue anymore
  const cleansedConfigData = doubleParseIfNecessary(gridConfig.configData);
  const { appliedFilters, gridViewId } = cleansedConfigData;
  return {
    filterViewId: gridConfig.gridConfigId,
    displayName: gridConfig.gridConfigName,
    appliedFilters,
    gridConfigTypeId: gridConfig.gridConfigTypeId.toLowerCase(),
    gridViewId,
    gridConfigOwnerUsername: gridConfig.gridConfigOwnerUsername,
  };
};

export const getAllGridConfigsRaw = () => {
  return axios.get('/gridconfig').then((response) => {
    const allConfigs = get(response, 'data', emptyArray);
    const parsedConfigs = allConfigs.map((config) => parseConfig(config));
    return parsedConfigs;
  });
};

export const getAllGridConfigs = () => {
  const gridConfigs$ = from(getAllGridConfigsRaw());
  return gridConfigs$;
};

export const getAllOrdersGridConfigs = () => {
  const getAndTransform = axios.get('/gridconfig').then((response) => {
    const allConfigs = get(response, 'data', emptyArray);
    const orderGridConfigs = allConfigs.filter((config) => config.gridConfigTypeId.toLowerCase() === CONFIG_TYPE_ORDERS);
    const parsedConfigs = orderGridConfigs.map((config) => parseConfig(config));
    return parsedConfigs;
  });

  const gridConfigs$ = from(getAndTransform);
  return gridConfigs$;
};

export const getAllShipmentsGridConfigs = () => {
  const getAndTransform = axios.get('/gridconfig').then((response) => {
    const allConfigs = get(response, 'data', emptyArray);
    const shipmentsGridConfigs = allConfigs.filter((config) => config.gridConfigTypeId.toLowerCase() === CONFIG_TYPE_SHIPMENTS);
    const parsedConfigs = shipmentsGridConfigs.map((config) => parseConfig(config));
    return parsedConfigs;
  });

  const gridConfigs$ = from(getAndTransform);
  return gridConfigs$;
};

export const getAllCustomersGridConfigs = () => {
  const getAndTransform = axios.get('/gridconfig').then((response) => {
    const allConfigs = get(response, 'data', emptyArray);
    const customersGridConfigs = allConfigs.filter((config) => config.gridConfigTypeId.toLowerCase() === CONFIG_TYPE_CUSTOMERS);
    const parsedConfigs = customersGridConfigs.map((config) => parseConfig(config));
    return parsedConfigs;
  });

  const gridConfigs$ = from(getAndTransform);
  return gridConfigs$;
};

export const getAllFulfillmentsGridConfigs = () => {
  const getAndTransform = axios.get('/gridconfig').then((response) => {
    const allConfigs = get(response, 'data', emptyArray);
    const fulfillmentsGridConfigs = allConfigs.filter((config) => config.gridConfigTypeId.toLowerCase() === CONFIG_TYPE_FULFILLMENTS);
    const parsedConfigs = fulfillmentsGridConfigs.map((config) => parseConfig(config));
    return parsedConfigs;
  });
  return getAndTransform;
};

export const saveNewOrdersGridConfig = (filterView) => {
  const config = makeConfig(filterView, CONFIG_TYPE_ORDERS);
  const post = axios.post('gridconfig', config).then((response) => {
    const gridConfig = get(response, 'data', emptyArray);
    return parseConfig(gridConfig);
  });

  const gridConfig$ = from(post);
  return gridConfig$;
};

export const saveNewShipmentsGridConfig = (filterView) => {
  const config = makeConfig(filterView, CONFIG_TYPE_SHIPMENTS);
  const post = axios.post('gridconfig', config).then((response) => {
    const gridConfig = get(response, 'data', emptyArray);
    return parseConfig(gridConfig);
  });

  const gridConfig$ = from(post);
  return gridConfig$;
};

export const saveNewCustomersGridConfig = (filterView) => {
  const config = makeConfig(filterView, CONFIG_TYPE_CUSTOMERS);
  const post = axios.post('gridconfig', config).then((response) => {
    const gridConfig = get(response, 'data', emptyArray);
    return parseConfig(gridConfig);
  });

  const gridConfig$ = from(post);
  return gridConfig$;
};

export const saveNewFulfillmentsGridConfig = (filterView) => {
  const config = makeConfig(filterView, CONFIG_TYPE_FULFILLMENTS);
  const post = axios.post('gridconfig', config).then((response) => {
    const gridConfig = get(response, 'data', emptyArray);
    return parseConfig(gridConfig);
  });

  return post;
};

export const saveExistingOrdersGridConfig = (filterView) => {
  const config = makeConfig(filterView, CONFIG_TYPE_ORDERS);
  const { gridConfigId } = config;
  const post = axios.post(`gridconfig/${gridConfigId}`, config).then((response) => {
    const gridConfig = get(response, 'data', emptyArray);
    return parseConfig(gridConfig);
  });

  const gridConfig$ = from(post);
  return gridConfig$;
};

export const saveExistingShipmentsGridConfig = (filterView) => {
  const config = makeConfig(filterView, CONFIG_TYPE_SHIPMENTS);
  const { gridConfigId } = config;
  const post = axios.post(`gridconfig/${gridConfigId}`, config).then((response) => {
    const gridConfig = get(response, 'data', emptyArray);
    return parseConfig(gridConfig);
  });

  const gridConfig$ = from(post);
  return gridConfig$;
};

export const saveExistingCustomersGridConfig = (filterView) => {
  const config = makeConfig(filterView, CONFIG_TYPE_CUSTOMERS);
  const { gridConfigId } = config;
  const post = axios.post(`gridconfig/${gridConfigId}`, config).then((response) => {
    const gridConfig = get(response, 'data', emptyArray);
    return parseConfig(gridConfig);
  });

  const gridConfig$ = from(post);
  return gridConfig$;
};

export const saveExistingFulfillmentsGridConfig = (filterView) => {
  const config = makeConfig(filterView, CONFIG_TYPE_FULFILLMENTS);
  const { gridConfigId } = config;
  const post = axios.post(`gridconfig/${gridConfigId}`, config).then((response) => {
    const gridConfig = get(response, 'data', emptyArray);
    return parseConfig(gridConfig);
  });

  return post;
};

export const deleteFulfillmentsGridConfig = (filterView) => {
  const gridConfigId = filterView.filterViewId;
  const httpDelete = axios.delete(`gridconfig/${gridConfigId}`);

  return httpDelete;
};

export const deleteGridConfig = (filterView) => {
  const gridConfigId = filterView.filterViewId;
  const httpDelete = axios.delete(`gridconfig/${gridConfigId}`);

  const removedGridConfig$ = from(httpDelete);
  return removedGridConfig$;
};
